import React, { FC } from 'react';
import { Connect } from './AsideSearchSnippetsContainer';
import { EnterpriseSnippet } from './enterprise/EnterpriseSnippet';
import { LawyerSnippet } from './lawyer/LawyerSnippet';
import { LegalBasisSnippet } from './legal-basis/LegalBasisSnippet';
import './shortcut_snippets.scss';
import { ResultsType } from '../../../state/reducers/results.types';

type Props = {
  enterprise: ResultsType['snippets']['enterprise'];
  lawyer: ResultsType['snippets']['professional'];
  hasLegalBasis: boolean;
};

export const RawAsideSearchSnippets: FC<Props> = ({
  enterprise,
  lawyer,
  hasLegalBasis,
}) => (
  <>
    {!!enterprise && (
      <Wrapper>
        <EnterpriseSnippet
          enterprise={enterprise}
          key={enterprise.enterpriseId}
        />
      </Wrapper>
    )}
    {!!lawyer && (
      <Wrapper>
        <LawyerSnippet lawyer={lawyer} key={lawyer.lawyerId} />
      </Wrapper>
    )}
    {hasLegalBasis && (
      <Wrapper>
        <LegalBasisSnippet />
      </Wrapper>
    )}
  </>
);

export const AsideSearchSnippets = Connect(RawAsideSearchSnippets);

const Wrapper: FC = props => <div className="shortcut-snippet" {...props} />;
